import styled from "styled-components";
//let { innerHeight, innerWidth } = window

// const ksh42 = require("../../static/image/ksh42.png");

export const Container = styled.div`
    width:100%;
    .container{
        width:100%;
        background-color: #ffffff;
      .date-picker .adm-list-item-content {
        //flex-basis: initial;
        height: 50px;
      }
      .imgUpLoad{
        width:98vw;
        display: table-cell;
        text-align: center;
        padding-top: 30px;
        padding-left: 1vw;
        
        .uploadText{
          font-size: small;
          line-height: 30px;
          height: 30px;
          color: gray;
        }
      }
      .vodUpLoad{
        width:100vw;
        height: 180px;
        display: table-cell;
        text-align: center;
        
        .vodUpLoad2{
          width:80vw;
          height: 120px;
          margin-left: 10vw;
          margin-top: 30px;
          background-color: #ffffff;
          padding-top: 10px;
          border: 1px dashed #888888;
          border-radius: 5px;
        }
        .uploadText{
          font-size: small;
          line-height: 30px;
          height: 30px;
          color: gray;
        }
      }

      .form{
        background-color: #ffffff;
        .shootingTime{
          font-size: small;
          line-height: 30px;
          height: 30px;
          color: darkgray;
        }
        .listItem{
          margin-top: 8px;
        }
      }
    }

`
